<template>
  <div>    
      <!-- <h3 class="mb text-left title">Add a Task</h3> -->
      
      <at at="@" :members="getPeople" v-model="text" name-key="_atname" :suffix="suffix" :hideOnBlur="hideOnBlur">
        <template slot="item" slot-scope="s">
                <img v-if="s.item._atimage" :src="s.item._atimage">
                <span>&nbsp;&nbsp;</span>
                <span v-text="s.item._atname"></span>
          </template>

          <span slot="embeddedItem" slot-scope="s">
              <span class="tag">
                <a :href="s.current._aturl">{{ s.current._atname }}</a>
                <!-- <a v-if="s.current.CreatedByEmpID" :href="s.current.CreatedByEmpID">{{ s.current.AssetTitle }}</a> -->
              </span>
          </span>

          <at at="#" :members="getDocs" v-model="text" name-key="_atname" :suffix="suffix" :hideOnBlur="hideOnBlur">
          <template slot="item" slot-scope="s">
                <img v-if="s.item._atimage" :src="s.item._atimage">
                <i v-if="s.item.AssetType" :class="getIcon(s.item.AssetType)"/>
                <span>&nbsp;&nbsp;</span>
                <span v-text="s.item._atname"></span>
          </template>

          <span slot="embeddedItem" slot-scope="s">
              <span class="tag">
                <a :href="s.current._aturl">{{ s.current._atname }}</a>
                <!-- <a v-if="s.current.CreatedByEmpID" :href="s.current.CreatedByEmpID">{{ s.current.AssetTitle }}</a> -->
              </span>
          </span>

          <b-form-group
                  label=""
                  label-for="task-field"
                  breakpoint="md"
                  >
                  <!--
                  <b-button v-if="this.backable" variant="default" @click="goBack()">
                    <i class="fa fa-angle-left fa-lg" />
                  </b-button>
                  -->
            <b-row>
                <b-col>
                <b-input-group>
                  <div contenteditable 
                      placeholder="Enter a task and hit enter or click more for advanced"
                      id="task-field"
                      class="editor"
                      >
                    </div>
                  <b-input-group-append>
                    <b-button variant="success" class="width-100 mb-lg-0 mb-xs mr-xs" @click='saveTask' :disabled="this.loading">ADD</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>
          </b-form-group>
        </at>
      </at>
  </div>
</template>


<script>
import Widget from '@/components/Widget/Widget';
import At from 'vue-at';
import { mapState, mapActions } from 'vuex';
import moment from 'moment';

export default {
  name: 'Compose',
  components: { Widget, At },
  //props: ['data'],
  data() {
    return {
      wygContent: '',
      text: '',
      hideOnBlur: true,
      suffix: ' ',
    };
  },

  created() {
      this.init();
  },

  methods: { 

    ...mapActions('customer', ['getAssets', 'getEmployees', 'getSites']),
    ...mapActions('tasks', ['addTask']),

    async init() {
      await this.getAssets( {customerID: this.customerID });
      if(!this.siteID)
        await this.getSites({ customerID: this.customerID })
      await this.getEmployees( {siteID: this.siteID });
    },

    goBack() {
      this.$router.go(-1);
    },

    getIcon(type) {
      let iconClass = '';
      switch(type) {
        case 'XLS'    : iconClass='fa fa-file-excel-o'; break;
        case 'DOC'    : iconClass='fa fa-file-word-o'; break;
        case 'PDF'    : iconClass='fa fa-file-pdf-o'; break;
        case 'PPT'    : iconClass='fa fa-file-powerpoint-o'; break;
        default       : iconClass='fa fa-file'; break;
      }
      return iconClass;
    },

    async saveTask() {
      let employeeID;
      let employeeName;

      /* eslint-disable */
      console.log('Add task called with task=' + this.text);
      let removeHtml = this.text.replace(/<\/?[^>]+(>|$)/g, "");
      //console.log('removeHtml:' + removeHtml);
      let trimmedText = removeHtml.replace(/\s{2}/g, ' ');
      console.log('TrimmedText:' + trimmedText);

      let regexp = /<a .*?href=\"(.+)\">(.+)<.a>/ig;
      let regexp1 = /\/profile\/(.+)/i;

      let match = regexp.exec(this.text); // match[0] = <a href="/">Linda Davis</a>   match[1]= /profile/2    match[2]= Linda Davis      

      while (match != null) {
        let result = match[1].match(regexp1);
        if (result != null) {
          employeeID = result[1];
          employeeName = match[2];
          console.log('EmployeeID:' + employeeID);
          console.log('EmployeeName:' + employeeName);
        } else {
          let assetUrl = match[1];
          let assetName = match[2];
          console.log('Asset Url:' + assetUrl + ', Asset Name:' + assetName);
        }        
        match = regexp.exec(this.text);
      }

      let taskToAdd = {
        AssignedToEmpID : employeeID,
        CreatedByEmpID  : this.userID,
        //'Title'           : this.trimmedText,
        Title           : this.text,
        Status          : 'INCOMPLETE',
        TaskType        : 'YOUR_TASKS',
        SiteID          : this.siteID,
        DueDate         : moment().utc().format('YYYY-MM-DDTHH:mm:ss'),
        Active          : true,
      };

      console.log('Adding task:' + JSON.stringify(taskToAdd));
      await this.addTask(taskToAdd);
      this.text = "";
    },


  },

  computed: {
    ...mapState({
        loading: state => state.alert.loading,
        assets: state => state.customer.assets,
        employees: state => state.customer.employees,
        customerID: state => state.customer.customerID,
        userID: state => state.customer.userID,
        siteID: state => state.customer.siteID,
    }),

    backable() {
      return this.$route.path.indexOf('/app/task/') !== -1
    },

    getPeople() {
      this.employees.forEach(t => {
        t._atname = t.EmployeeName,
        t._atimage = 'https://randomuser.me/api/portraits/men/2.jpg'
        t._aturl = `/profile/${t.id}`
      });
      return this.employees;
    },

    getDocs() {
      this.assets.forEach(t => {
        t._atname = t.AssetTitle,
        t._atimage = '',
        t._aturl = t.AssetUrl
      });
      return this.assets;
    },

  },

  watch: {
    saved: function(oldVal, newVal) {
        this.text = '';
    }
  },

};
</script>

<style src="./Compose.scss" lang="scss" />
